// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import { Form, FormInstance, Select } from "antd";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";
import { getCountriesList } from "../../api/shared-api";
import { useDispatch } from "react-redux";
import { LOADING } from "../../store/actions";
import ReactCountryFlag from "react-country-flag";

const { Option } = Select;

const AddEditBank: React.FC = (): ReactElement => {
  // eslint-disable-next-line no-restricted-globals
  const queryParams = new URLSearchParams(location.search);
  const edit: string | null = queryParams.get("edit");
  const dispatch: any = useDispatch();
  const [form]: [FormInstance<any>] = Form.useForm();
  const [countriesList, setCountriesList] = useState<any[]>([]);

  useEffect(() => {
    fetchCountriesListData();
  }, []);

  const fetchCountriesListData = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    const data = await getCountriesList();

    if (data !== undefined) {
      setCountriesList(data);
    }

    dispatch({ type: LOADING, payload: false });
  };

  return (
    <section className="flex flex-col">
      <BreadcrumbComponent />

      <div className="flex flex-col py-[2%] bg-white rounded-[20px]">
        <h3 className=" text-xl border-b-[1px] border-black-200 px-[2%] pb-4">
          {edit ? "Edit bank" : "Create an bank"}
        </h3>
        {
          <Form form={form} className="p-[2%]">
            <div className="flex-wrap flex justify-between">
              <div className="flex flex-col w-full md:w-[48%]">
                <Label text="NameEn" />
                <Form.Item
                  name="nameEn"
                  rules={[
                    {
                      required: true,
                      message: "Please input NameEn!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter NameEn" />
                </Form.Item>
              </div>
              <div className="flex flex-col w-full md:w-[48%]">
                <Label text="NameAr" />
                <Form.Item
                  name="nameAr"
                  rules={[
                    {
                      required: true,
                      message: "Please input NameAr!",
                    },
                  ]}
                >
                  <CustomInput placeholder="Enter NameAr" />
                </Form.Item>
              </div>

              <div className="field flex flex-col w-[49%]">
                <Label text="Country" />
                <Form.Item
                  name="Country"
                  rules={[
                    {
                      required: true,
                      message: "Please select the Country!",
                    },
                  ]}
                >
                  <Select placeholder="Select Country" allowClear showSearch>
                    {countriesList.map((country) => (
                      <Option value={country.id} key={country.nameEn}>
                        <div className="flex items-center gap-1">
                          <ReactCountryFlag
                            style={{
                              fontSize: "24px",
                              marginInlineEnd: "8px",
                            }}
                            countryCode={country?.countryCode}
                            svg
                          />
                          <span>{country.nameEn}</span>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>

              <div className="field flex flex-col w-[49%]">
                <Label text="Currency" />
                <Form.Item
                  name="Currency"
                  rules={[
                    {
                      required: true,
                      message: "Please select the Currency!",
                    },
                  ]}
                >
                  <Select placeholder="Select Currency" allowClear showSearch>
                    {countriesList.map((country) => (
                      <Option
                        value={country.currencyCode}
                        key={country.currencyCode}
                      >
                        <div className="flex items-center gap-1">
                          <ReactCountryFlag
                            style={{
                              fontSize: "24px",
                              marginInlineEnd: "8px",
                            }}
                            countryCode={country?.countryCode}
                            svg
                          />
                          <span>{country.currencyCode}</span>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>

            <div className="flex w-full flex-wrap items-center justify-between mt-7 border-t-[1px] border-gray-900 pt-5">
              <div className="flex w-[28%] md:w-[48%]">
                <a className=" cursor-pointer underline text-gray-700">Reset</a>
              </div>
              <div className="flex justify-between items-center w-[70%] md:w-[48%]">
                <button
                  type="button"
                  className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
                >
                  Cancel
                </button>
                <button
                  className="rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-xs md:text-sm font-semibold border-[1px] border-blue-500 text-white"
                  type="button"
                >
                  {edit ? "Update bank" : "Create bank"}
                </button>
              </div>
            </div>
          </Form>
        }
      </div>
    </section>
  );
};

export default AddEditBank;
